// Wires marginx's "Go to" navigation chords + focus-search to the registry ids.
// Renders nothing; must live inside <KeyboardProvider> and react-router.
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useShortcut } from "keyboard/useKeyboard";
import { MarketContext } from "../../contexts/MarketContext";

/** The page's own search box, if it has one. */
export const findPageSearchInput = (): HTMLInputElement | null =>
  document.querySelector<HTMLInputElement>(
    'input[type="search"], input[placeholder*="search" i]',
  );

export function MarginxKeyboardBindings() {
  const navigate = useNavigate();
  const { setShowCommandModal } = useContext(MarketContext);

  useShortcut("go.trade", () => navigate("/"));
  useShortcut("go.portfolio", () => navigate("/portfolio"));
  useShortcut("go.watchlist", () => navigate("/watchlist"));
  useShortcut("go.leaderboard", () => navigate("/leaderboard"));
  useShortcut("go.referrals", () => navigate("/referrals"));
  useShortcut("go.history", () => navigate("/historical"));
  useShortcut("go.settings", () => navigate("/settings"));

  // Focus the page's search input if present. Most pages (the trading page
  // included) have none, and "/" used to do nothing there; the market search
  // that always exists is the ⌘K palette, so open that instead.
  const focusSearch = () => {
    // A modal (deposit, settings…) is open: "/" must not stack the palette on
    // top of it. Returning false lets the key pass through untouched.
    if (document.querySelector('[aria-modal="true"]')) return false;
    const el = findPageSearchInput();
    if (!el) {
      setShowCommandModal(true);
      return;
    }
    el.focus();
    el.select?.();
  };
  useShortcut("global.search", focusSearch);

  return null;
}
